export class AssoDissoRequest {
  createAssociation: string[];
  deleteAssociation: string[];

  constructor(createAssociation: string[], deleteAssociation: string[]) {
    this.createAssociation = createAssociation;
    this.deleteAssociation = deleteAssociation;
  }
}
